export default "__VITE_ASSET__B$fsjEEd__"